// Divider.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './Divider.css';

/**
 * Divider Component
 * 
 * This component renders a divider.
 * 
 * @returns {ReactNode} The rendered component.
 */
const Divider = ({ direction = "horizontal", height = "100%", width = "100%", color, margin = "7px" }) => {

  // ----- CONTEXT ----- //

  // Theme Context
  const { theme } = useTheme();

  // ----- CONSTANTS ----- //

  const dividerColor = color ?? theme.panel;

  // ----- RENDER ----- //

  return (
    <>
      {/* CONTAINER */}
      {direction === "vertical" ? (
        <div className="divider-container-vertical"
          style={{
            height: height,
            marginLeft: margin,
            marginRight: margin,
            borderColor: dividerColor,
          }}> </div>
      ) : (
        <div className="divider-container-horizontal"
          style={{
            width: width,
            marginTop: margin,
            marginBottom: margin,
            borderColor: dividerColor,
          }}></div>
      )}
    </>
  );
};

export default Divider;

